export default __webpack_public_path__ + "static/media/updateOrange.7cdc53a6.svg";